export const TOGGLE_LEFT_BAR: string = 'TOGGLE_LEFT_BAR';
export const TOGGLE_BOTTOM_BAR: string = 'TOGGLE_BOTTOM_BAR';
